window.current_status = document.querySelector('.gamification-status')
    ? document.querySelector('.gamification-status').dataset.status.split(',')
    : 'hidden';
(() => {
    function removeGift() {
        const giftVariant = document
            .querySelector('.gamification')
            .getAttribute('gift-variant');
        if (!giftVariant) return;
        // update cart
        fetch('/cart/update.js', {
            body: JSON.stringify({
                updates: {
                    [parseInt(giftVariant, 10)]: 0,
                },
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
            },
        }).then((response) => {
            if (response.ok) {
                localStorage.setItem('freeProductAdded', 'false');

                localStorage.setItem("id", "0");
                // We simply trigger an event so the mini-cart can re-render
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (window.themeVariables.settings.pageType === 'cart')
                    window.location.reload();
            }
        });
    }

    function addGift() {
        if (localStorage.getItem('gift_removed')) return;
        const giftVariant = document
            .querySelector('.gamification')
            .getAttribute('gift-variant');

        if (!giftVariant) return;
        // update cart
        fetch('/cart/add.js', {
            body: JSON.stringify({
                items: [
                    {
                        id: parseInt(giftVariant, 10),
                        quantity: 1,
                        properties: { _gift: true },
                    },
                ],
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
            },
        }).then((response) => {
            if (response.ok) {
                localStorage.setItem('freeProductAdded', 'true');
                localStorage.setItem("id", parseInt(giftVariant, 10));
                // We simply trigger an event so the mini-cart can re-render
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (window.themeVariables.settings.pageType === 'cart')
                    window.location.reload();
            }
        });
    }

    function gamificationHandle() {
        let giftGrantedState = false;
        let giftInCart = false;

        if (window.current_status[0] === 'all_granted') {
            giftGrantedState = true;
        }

        if (document.querySelector('.line-item[data-gift="true"]')) {
            giftInCart = true;
        }

        if (!giftInCart && giftGrantedState) {
            addGift();
        } else if (giftInCart && !giftGrantedState) {
            removeGift();
        }
    }
    function handleStatusChange() {
        setTimeout(() => {
            window.current_status = document.querySelector('.gamification-status')
                ? document
                    .querySelector('.gamification-status')
                    .dataset.status.split(',')
                : 'hidden';
            if (window.current_status.includes('shipping_progress'))
                localStorage.removeItem('gift_removed');
            if (window.current_status !== 'hidden') gamificationHandle();
        }, 1000);
    }
    window.addEventListener('load', () => {
        document.addEventListener('click', (e) => {
            if (
                e.target.tagName === 'A' &&
                e.target.className.indexOf('remove-gift') > -1
            ) {
                localStorage.setItem('gift_removed', true);
            }
        });
        handleStatusChange();
    });

    'cart:change,line-item:change,cart:refresh'.split(',').forEach((e) => {
        document.addEventListener(e, () => {
            handleStatusChange();
        });
    });
})();